import React, { useState, useRef, useContext } from "react";
import {
    useFloating,
    autoUpdate,
    offset,
    flip,
    arrow,
    shift, size,

    useClick,
    useDismiss,
    useRole,
    useInteractions, FloatingFocusManager
} from '@floating-ui/react';
import { IsMobileContext } from "../../context/contexts";

const PopoverInput = ({ icon, children, inputText, isLoading, onTextUpdate, filterText, isOpen, setIsOpen, doubleWidth, disabled, footer,header }) => {
    const arrowRef = useRef(null);
    const scrollPaneRef = useRef(null);
    const isMobile = useContext(IsMobileContext);


    const floatingOpts = {
        open: isOpen,
        onOpenChange: (a, event, reason) => {
            if (reason == "click") {
                if (a) {
                    setIsOpen(true);
                }
            } else {
                setIsOpen(a);
            }
        },
        whileElementsMounted: autoUpdate,
    };

    if (isMobile) {
        delete scrollPaneRef?.current?.style?.maxHeight;
        floatingOpts.strategy = "fixed";
        floatingOpts.middleware = [{
            name: "originMiddleware",
            fn({ x, y }) {
                return {
                    x: 0,
                    y: 0,
                    reset: true,
                };
            },
        }];
    } else {
        floatingOpts.strategy = "absolute";

        floatingOpts.middleware = [offset(10), shift(), size({
            apply({ availableHeight, elements }) {
                if (availableHeight > 450) {
                    availableHeight = 450;
                }
                const value = `${Math.max(0, availableHeight - 25)}px`;
                scrollPaneRef.current.style.maxHeight = value;
            },
        }), arrow({
            element: arrowRef,
            padding: 5
        })];
    }
    const { refs, floatingStyles, context, middlewareData } = useFloating(floatingOpts);
    let tweakedFloatingStyles = null;
    if (isMobile) {
        tweakedFloatingStyles = {
            ...floatingStyles,
            width: "100%",
            height: "100%",
        };
    } else {
        tweakedFloatingStyles = {
            ...floatingStyles,
        };
    }
    const click = useClick(context);
    const dismiss = useDismiss(context);
    const role = useRole(context);

    // Merge all the interactions into prop getters
    const { getReferenceProps, getFloatingProps } = useInteractions([
        click,
        dismiss,
        role,
    ]);


    var textboxValue = filterText ?? "";
    var textboxPlaceholder = inputText;

    if (disabled) {
        return (<div className="relative w-full flex-1">
            <input type="text" disabled className="form-input" placeholder={textboxPlaceholder} value={textboxValue} />
            <span className="absolute left-3 top-[20px] -translate-y-1/2 pointer-events-none text-content_2">
                {icon}
            </span>
        </div>);
    }

    if (isLoading) {
        return (<div className="relative w-full flex-1">
            <input type="text" readOnly className="form-input" placeholder="Loading..." value="" />
            <span className="absolute left-3 top-[20px] -translate-y-1/2 pointer-events-none text-content_2">
                {icon}
            </span>
        </div>);
    }
    let isReadOnly = true;
    if (onTextUpdate) {
        isReadOnly = false;
    } else {
        onTextUpdate = (t) => { }
    }

    let minWidth = (doubleWidth ? "min-w-172" : "min-w-100");

    if (isMobile) {
        minWidth = "";
    }

    var paneSize = {height:"100%"};
    if(footer!=null){
        if(isMobile){
            paneSize.height = "calc( 87dvh - 50px )";
        }else{
            paneSize.height="calc(100% - 50px)"
        }
    } 
    return (
        <div className="relative w-full flex-1 z-auto">
            <input readOnly={isReadOnly} type="text" ref={refs.setReference} {...getReferenceProps()} value={textboxValue} onChange={(e) => onTextUpdate(e.target.value)} className="form-input" placeholder={textboxPlaceholder} />
            <span className="absolute left-3 top-[20px] -translate-y-1/2 pointer-events-none text-content_2">
                {icon}
            </span>
            {isOpen && (
                <FloatingFocusManager context={context} modal={false} initialFocus={0}>
                    <div
                        ref={refs.setFloating}
                        style={tweakedFloatingStyles}
                        {...getFloatingProps()}
                        className={" z-999 " + minWidth}
                    >
                        <div
                            ref={arrowRef}
                            className="h-4 w-4 bg-white border border-white border-t-content_4 border-l-content_4 rounded-[4px]"
                            style={{
                                position: 'absolute',
                                left: middlewareData.arrow?.x,
                                top: middlewareData.arrow?.y,
                                transform: "translate(0px, -8px) rotate(45deg)",
                                display: isMobile ? "none" : "block"
                            }}
                        />
                        <div className={"bg-white p-2 rounded-[8px] pl-3 pr-2 border border-content_4 shadow-2xl " + (isMobile ? "h-1/1" : "")}>
                            {header != null && (
                                <div>
                                    {header}
                                </div>
                            )}
                            <div ref={scrollPaneRef} className="overflow-y-auto" style={paneSize}>
                                {children}
                            </div>
                            {footer != null && (
                                <div>
                                    {footer}
                                </div>
                            )}

                        </div>
                    </div>
                </FloatingFocusManager>
            )}
        </div>);
}
export default PopoverInput;
